import { recruiterTerms, TERMS_VERSION } from "../constants/platformTerms";
import { TermsAcceptancePanel } from "./TermsAcceptancePanel";

export function RecruiterTermsCard({
  accepted,
  onAcceptedChange,
  version = TERMS_VERSION,
}: {
  accepted: boolean;
  onAcceptedChange: (accepted: boolean) => void;
  version?: string;
}) {
  return (
    <TermsAcceptancePanel
      terms={recruiterTerms}
      masterAccepted={accepted}
      onMasterAcceptedChange={onAcceptedChange}
      version={version}
      accent="violet"
    />
  );
}
